import React, { useState, useEffect } from "react";
import "../../styles/Styles.css";

function Boards() {

    const [boards, setBoards] = useState([]);

    useEffect(() => {
        fetch('https://strapi.restauracjasamiswoi.pl/api/categories?populate=menu_items')
        .then(response => response.json())
        .then(data => {
            const category = data.data.find(item => item.name === 'KORYTO');

            if (category) {
                setBoards(category.menu_items);
            };
        });
    }, []);

    return (

        <div className="container-fluid section-cream-background">
            <div className="container section-menu-item">
                <div className="menu-left-70">
                    <p className="menu-item-title-font fs-1 fw-bold">KORYTO</p>
                    <hr/>
                    {boards.map((board) => (
                        <div key={board.id} className="container">
                            <div className="dish-name-container d-flex justify-content-between">
                                <p className="menu-item-title-font fs-5 m-0">{board.name}</p>
                                <p className="fs-5 m-0">{board.price}zł</p>
                            </div>
                            <p className="ingridients-container fs-6 m-0 fw-lighter">{board.ingredients}</p>
                            <div className="mb-3 mt-3 divide-line"/>
                        </div>
                    ))}
                    </div>
                    <div className="dish-photo-right-container-25">
                        <img src={require("../../assets/menu/board.webp")} className="dish-photo-soups img-menu img-rounded shadow" />
                </div>
            </div>
        </div>

    )
}

export default Boards;